import api from "./api";

const API_URL = "/IoTDevice";

const unwrap = (res) => res?.data ?? null;

export const getIoTDevices = async () =>
    unwrap(await api.get(API_URL));

export const createIoTDevice = async (device) =>
    unwrap(await api.post(API_URL, device));

export const getDevicePosition = async (id) =>
    unwrap(await api.get(`${API_URL}/${id}/position`));

export const simulateMovement = async (deviceId) => {
    let lat = 52.52;
    let lng = 13.40;

    setInterval(() => {
        lat += (Math.random() - 0.5) * 0.01;
        lng += (Math.random() - 0.5) * 0.01;

        updateTelemetry(deviceId, lat, lng);
    }, 2000);
};
export const getDeviceRoute = async (id) =>
    unwrap(await api.get(`${API_URL}/${id}/route`));

export const exportDeviceRouteCsv = async (id) => {
    const res = await api.get(`${API_URL}/${id}/export`, {
        responseType: "blob",
    });

    return res.data;
};

export const getIoTDeviceById = async (id) =>
    unwrap(await api.get(`${API_URL}/${id}`));

export const getIoTDeviceByTrackingNumber = async (trackingNumber) =>
    unwrap(await api.get(`${API_URL}/tracking/${trackingNumber}`));

export const updateIoTDevice = async (id, device) =>
    unwrap(await api.put(`${API_URL}/${id}`, device));

export const deleteIoTDevice = async (id) =>
    unwrap(await api.delete(`${API_URL}/${id}`));

export const deleteIoTDeviceByTrackingNumber = async (trackingNumber) =>
    unwrap(await api.delete(`${API_URL}/tracking/${trackingNumber}`));

export const sendHeartbeat = async (id) =>
    unwrap(await api.post(`${API_URL}/${id}/heartbeat`));

export const checkDeviceOnline = async (id) =>
    unwrap(await api.get(`${API_URL}/${id}/online`));
export const getTelemetryHistory = async (id) =>
    unwrap(await api.get(`${API_URL}/${id}/telemetry-history`));

export const updateTelemetry = async (
    deviceId,
    latitude,
    longitude,
    accuracyMeters = null,
    speedKmh = null,
    headingDegrees = null
) => {
    try {
        const res = await api.post(`${API_URL}/telemetry`, {
            deviceId,
            latitude,
            longitude,
            accuracyMeters,
            speedKmh,
            headingDegrees
        });

        return res.data;
    } catch (error) {
        console.error("Telemetry error:", error);

        throw new Error(
            error?.response?.data?.message ||
            error?.message ||
            "Failed to update telemetry"
        );
    }
};
export default {
    getIoTDevices,
    createIoTDevice,
    getDevicePosition,
    updateTelemetry,
    getDeviceRoute,
    exportDeviceRouteCsv,
    getIoTDeviceById,
    getIoTDeviceByTrackingNumber,
    updateIoTDevice,
    deleteIoTDevice,
    deleteIoTDeviceByTrackingNumber,
    sendHeartbeat,
    checkDeviceOnline,
    getTelemetryHistory,
    simulateMovement,
};